export const QUERY_KEYS = {
  // Users
  USERS_KEY: 'users',

  // Clients
  CLIENTS_KEY: 'clients',
  BALANCES: 'balances',
  // Appointments
  APPOINTMENTS_KEY: 'appointments',

  // Sales
  SALES_KEY: 'sales',

  // Transactions
  TRANSACTIONS_KEY: 'transactions',

  // Products/Services
  SERVICES_KEY: 'services',

  SLUG_KEY: 'slug',
  OWNER_KEY: 'owner',
};

/**
 * 🚀 Query Key Factory de tufirma.pro
 * Unifica todas las llaves para asegurar sincronización total en TanStack Query.
 */
export const APP_KEYS = {
  // --- AUTH & USUARIOS ---
  auth: {
    all: ['auth'] as const,
    profile: (uid: string) => [...APP_KEYS.auth.all, 'profile', uid] as const,
  },

  // --- CLIENTES ---
  clients: {
    all: ['clients'] as const,
    owner: (ownerId: string) => [...APP_KEYS.clients.all, ownerId] as const,
    list: (ownerId: string) =>
      [...APP_KEYS.clients.owner(ownerId), 'list'] as const,
    detail: (ownerId: string, clientId: string) =>
      [...APP_KEYS.clients.owner(ownerId), 'detail', clientId] as const,
  },

  // --- SERVICIOS ---
  services: {
    all: ['services'] as const,
    owner: (ownerId: string) => [...APP_KEYS.services.all, ownerId] as const,
    list: (ownerId: string) =>
      [...APP_KEYS.services.owner(ownerId), 'list'] as const,
    active: (ownerId: string) =>
      [...APP_KEYS.services.list(ownerId), 'active'] as const,
    detail: (ownerId: string, serviceId: string) =>
      [...APP_KEYS.services.owner(ownerId), 'detail', serviceId] as const,
  },

  // --- PRODUCTOS ---
  products: {
    all: ['products'] as const,
    owner: (ownerId: string) => [...APP_KEYS.products.all, ownerId] as const,
    list: (ownerId: string) =>
      [...APP_KEYS.products.owner(ownerId), 'list'] as const,
    detail: (ownerId: string, productId: string) =>
      [...APP_KEYS.products.owner(ownerId), 'detail', productId] as const,
  },

  // --- CITAS / AGENDA ---
  appointments: {
    all: ['appointments'] as const,
    owner: (ownerId: string) =>
      [...APP_KEYS.appointments.all, ownerId] as const,
    list: (ownerId: string, date?: string) => {
      const base = [...APP_KEYS.appointments.owner(ownerId), 'list'] as const;
      return date ? ([...base, { date }] as const) : base;
    },
    detail: (ownerId: string, appointmentId: string) =>
      [
        ...APP_KEYS.appointments.owner(ownerId),
        'detail',
        appointmentId,
      ] as const,
  },

  // --- VENTAS ---
  sales: {
    all: ['sales'] as const,
    owner: (ownerId: string) => [...APP_KEYS.sales.all, ownerId] as const,
    list: (ownerId: string) =>
      [...APP_KEYS.sales.owner(ownerId), 'list'] as const,
    detail: (ownerId: string, saleId: string) =>
      [...APP_KEYS.sales.owner(ownerId), 'detail', saleId] as const,
  },

  // --- FINANZAS (Tu lógica corregida) ---
  finance: {
    all: ['finance'] as const,
    owner: (ownerId: string) => [...APP_KEYS.finance.all, ownerId] as const,
    // Balances
    balances: (ownerId: string) =>
      [...APP_KEYS.finance.owner(ownerId), 'balances'] as const,
    balanceList: (ownerId: string) =>
      [...APP_KEYS.finance.balances(ownerId), 'list'] as const,
    balanceDetails: (ownerId: string) =>
      [...APP_KEYS.finance.balances(ownerId), 'detail'] as const,
    balanceDetail: (ownerId: string, targetId: string) =>
      [...APP_KEYS.finance.balanceDetails(ownerId), targetId] as const,
    // Transacciones
    transactions: (ownerId: string) =>
      [...APP_KEYS.finance.owner(ownerId), 'transactions'] as const,
    workerTransactions: (ownerId: string, workerId: string) =>
      [...APP_KEYS.finance.transactions(ownerId), workerId] as const,
    // Cierres
    settlements: (ownerId: string) =>
      [...APP_KEYS.finance.owner(ownerId), 'settlements'] as const,
  },

  // --- ADMIN & GLOBAL ---
  admin: {
    all: ['admin'] as const,
    globalPaymentMethods: ['admin', 'global', 'payment-methods'] as const,
    settings: (ownerId: string) => ['admin', 'settings', ownerId] as const,
  },

  // --- PÁGINA PÚBLICA / SLUGS ---
  slugs: {
    all: ['slugs'] as const,
    detail: (slug: string) => [...APP_KEYS.slugs.all, slug] as const,
  },
};
